import React, { useState } from "react";
import { TemplateItem } from "..";
import { Accordion, AccordionTab } from "primereact/accordion";

export default function TabviewTemplate({
	data,
	lockerType,
	onChange,
	disabled = false,
	checked,
	setChecked,
	className,
	editingDone,
	setEditingDone,
	handleCheckedChange,
	checkedStates,
}) {
	console.log({ data });
	return (
		<div>
			<p className="font-bold text-lg">
				To insert a variable in the messages, type{" "}
				<b className="text-red-500">$</b> for the dropdown list to appear
			</p>
			<Accordion activeIndex={0}>
				{data.map((element, key) => (
					<AccordionTab header={element.messageTitle} key={key}>
						<TemplateItem
							disabled={disabled}
							checked={
								checkedStates?.[element.operatorMessageTemplateId]
								// editingDone
								// 	? checkedStates?.[element.operatorMessageTypeId]
								// 	: element.checked === true
							}
							setChecked={(isChecked) =>
								handleCheckedChange(
									element.operatorMessageTemplateId,
									isChecked
								)
							}
							checkedStates={checkedStates}
							title={element.messageTitle}
							subtitle={`for ${lockerType} Locker`}
							appMessage={element.messageViaApp}
							smsMessage={element.messageViaSms}
							messageMedia={element.messageMedia}
							variable={element.variableNames}
							operatorMessageTypeId={element.operatorMessageTypeId}
							onChange={onChange}
							setEditingDone={setEditingDone}
						/>
					</AccordionTab>
				))}
			</Accordion>
		</div>
	);
}
